import React, {memo} from "react";
import {SequenceComponentHelper} from "../../extensions/SequenceComponentHelper";
import {COLLAPSED_NESTED_NODE_HEIGHT, NESTED_NODE_HORIZONTAL_MARGIN} from "../../stylingConstants";
import {DefaultSequenceComponent} from "../../components";
import styled from '@emotion/styled';
import {Control} from "rete-react-render-plugin";

const StyledNestedNodeDiv = styled.div`
  height: ${props => props.$isNodeCollapsed ? COLLAPSED_NESTED_NODE_HEIGHT : "auto"};
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 16px 0px;
`;

const StyledVideoControlsContainerDiv = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-left: ${NESTED_NODE_HORIZONTAL_MARGIN};
  margin-right: ${NESTED_NODE_HORIZONTAL_MARGIN};
`;

const StyledVideoFileControlContainerDiv = styled.div`
  display: flex;
  flex: 1;
  align-self: stretch;
  width: 100%;
  > div {
    width: 100% !important;
    flex: 1 !important;
  }
`;

const StyledGridContainerDiv = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(2, 1fr);
  column-gap: 16px;
  row-gap: 16px;
  margin-top: 16px;
`;

const DefaultSequenceVideo = ({controls, bindControl, isNodeCollapsed}) => {

    if (controls.length === 0) return null;

    let videoUUID = null;
    controls.forEach(control => {
        const controlKey = control.key.split('_');
        if (controlKey[1] === DefaultSequenceComponent.VIDEO_CHILD_COMPONENT_KEY) {
            videoUUID = controlKey[0];
        }
    })

    if (!videoUUID) return null;

    const videoFileControl = controls.find(control => control.key.includes(SequenceComponentHelper.getVideoFileKey(videoUUID)));
    const videoMappingControl = controls.find(control => control.key.includes(SequenceComponentHelper.getVideoMappingKey(videoUUID)));
    const stereoModeControl = controls.find(control => control.key.includes(SequenceComponentHelper.getVideoStereoModeKey(videoUUID)));
    const startFrameControl = controls.find(control => control.key.includes(SequenceComponentHelper.getVideoStartFrameKey(videoUUID)));
    const stopFrameControl = controls.find(control => control.key.includes(SequenceComponentHelper.getVideoStopFrameKey(videoUUID)));

    return (
        <>

            {/** NESTED NODE - VIDEO */}
            <StyledNestedNodeDiv $isNodeCollapsed={isNodeCollapsed}>

                    {/** VIDEO CONTROLS */}
                    <StyledVideoControlsContainerDiv>
                        <StyledVideoFileControlContainerDiv>
                            <Control key={videoFileControl.key} control={videoFileControl} innerRef={bindControl}/>
                        </StyledVideoFileControlContainerDiv>

                        {!isNodeCollapsed &&
                            <StyledGridContainerDiv>
                                <Control key={videoMappingControl.key}
                                         control={videoMappingControl}
                                         innerRef={bindControl}/>
                                <Control key={stereoModeControl.key}
                                         control={stereoModeControl}
                                         innerRef={bindControl}/>
                                <Control key={startFrameControl.key}
                                         control={startFrameControl}
                                         innerRef={bindControl}/>
                                <Control key={stopFrameControl.key}
                                         control={stopFrameControl}
                                         innerRef={bindControl}/>
                            </StyledGridContainerDiv>
                        }

                    </StyledVideoControlsContainerDiv>
            </StyledNestedNodeDiv>
        </>
    );
}

export default memo(DefaultSequenceVideo);